// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"Input_inputGroup__II6pW","disabled":"Input_disabled__ZfC_t","label":"Input_label__e6iCs","spin":"Input_spin__VbDCk","loader":"Input_loader__4tQiW"};